export enum apiUrlSubscription {
    GET_SUBSCRIPTION = 'v1/user_payment_plan/',
    CANCEL_SUBSCRIPTION = 'v1/user_payment_plan/cancel/',
}
